import { Outlet } from "@tanstack/react-router";

import EndDayDialog from "~/components/cash-register/end-day-dialog";
import EmployeeProfile from "~/components/employee/employee-profile";
import Alert from "~/components/miscellaneous/alert";
import { useNavigationManager } from "~/managers/use-navigation-manager";
import { BookingProvider } from "~/providers/booking-provider";
import { ButtonProvider } from "~/providers/button-provider";
import { CashLocationProvider } from "~/providers/cash-location-provider";
import { ConfigurationProvider } from "~/providers/configuration-provider";
import { CourseProvider } from "~/providers/course-provider";
import { CustomerProvider } from "~/providers/customer-provider";
import { DeviceProvider } from "~/providers/device-provider";
import { GeneralProvider } from "~/providers/general-provider";
import { LabelProvider } from "~/providers/label-provider";
import { LoadingProvider } from "~/providers/loading-provider";
import { NativeProvider } from "~/providers/native-provider";
import { OrderProvider } from "~/providers/order-provider";
import { PaymentMethodProvider } from "~/providers/payment-method-provider";
import { PermissionProvider } from "~/providers/permission-provider";
import PrintingProvider from "~/providers/printing-provider";
import { ProductProvider } from "~/providers/product-provider";
import { RealtimeProvider } from "~/providers/realtime-provider";
import { SectionProvider } from "~/providers/section-provider";
import { ServiceProvider } from "~/providers/service-provider";
import { ShiftProvider } from "~/providers/shift-provider";
import { TableProvider } from "~/providers/table-provider";
import { TerminalProvider } from "~/providers/terminal-provider";
import { UnsavedChangesProvider } from "~/providers/unsaved-changes-provider";
import ButtonDialog from "../button/button-dialog";
import { Header } from "../layout/header";
import { MobileMenu } from "../layout/mobile-menu";
import { Sidebar } from "../layout/sidebar";
import OnlineOrderManager from "../order/online-order-manager";
import DayDialog from "../shift/day-dialog";

export default function MerchantView() {
  const { navItems } = useNavigationManager();

  return (
    <DeviceProvider>
      <UnsavedChangesProvider>
        <ConfigurationProvider>
          <PermissionProvider>
            <GeneralProvider>
              <PrintingProvider>
                <TerminalProvider>
                  <CashLocationProvider>
                    <PaymentMethodProvider>
                      <CourseProvider>
                        <ServiceProvider>
                          <SectionProvider>
                            <ShiftProvider>
                              <ProductProvider>
                                <TableProvider>
                                  <LabelProvider>
                                    <CustomerProvider>
                                      <BookingProvider>
                                        <OrderProvider>
                                          <OnlineOrderManager />
                                          <ButtonProvider>
                                            <EmployeeProfile />

                                            <Header />
                                            <div className="flex flex-row flex-1 relative overflow-hidden">
                                              {/* <AppNotification /> */}
                                              <EndDayDialog />
                                              <UnsavedChangesProvider>
                                                <DayDialog />
                                              </UnsavedChangesProvider>
                                              <RealtimeProvider />
                                              <NativeProvider />
                                              <LoadingProvider />
                                              <Alert />
                                              <MobileMenu navItems={navItems} />
                                              <Sidebar navItems={navItems} />
                                              <UnsavedChangesProvider
                                                detectRouteChanges={false}
                                              >
                                                <ButtonDialog />
                                              </UnsavedChangesProvider>
                                              <Outlet />
                                            </div>
                                          </ButtonProvider>
                                        </OrderProvider>
                                      </BookingProvider>
                                    </CustomerProvider>
                                  </LabelProvider>
                                </TableProvider>
                              </ProductProvider>
                            </ShiftProvider>
                          </SectionProvider>
                        </ServiceProvider>
                      </CourseProvider>
                    </PaymentMethodProvider>
                  </CashLocationProvider>
                </TerminalProvider>
              </PrintingProvider>
            </GeneralProvider>
          </PermissionProvider>
        </ConfigurationProvider>
      </UnsavedChangesProvider>
    </DeviceProvider>
  );
}
